module.exports = __webpack_public_path__ + "yt.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/yt.svg
// module id = 893
// module chunks = 0